import styled from 'styled-components';

interface IProps {
  isMe?: boolean;
  isVehiclesExist?: boolean;
  margin?: string;
}

export const GarageSliderContainer = styled.div<IProps>`
  display: ${(props) => props.isVehiclesExist && 'flex'};
  max-width: 550px;
  width: 100%;
`;

export const GarageSliderWrapper = styled.div<IProps>`
  width: 100%;
  box-sizing: border-box;
  padding: 16px 6px 6px 6px;
  & > div {
    margin-bottom: 0;
    max-width: ${(props) => (props.isMe ? '434px' : '550px')};
    width: 100%;
    margin-left: ${(props) => (props.isMe ? '0px' : '0')};
    & > div {
      margin: 0 -6px;
    }
  }
`;

export const AddVehicleBlock = styled.div<IProps>`
  width: ${({ isVehiclesExist }) => (isVehiclesExist ? '90px' : '100%')};
  ${({ isMe, isVehiclesExist }) => isMe && isVehiclesExist && 'flex: 0 0 90px'};
  height: 130px;
  cursor: pointer;
  background: ${(props) => props.theme.colors.neutral.n1};
  border-radius: 6px;
  position: relative;
  top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.neutral.n4};

  div {
    font-family: ${(props) => props.theme.typography.fontFamily.primary};
    font-weight: ${(props) => props.theme.typography.fontWeight.regular};
    font-size: ${(props) => props.theme.typography.fontSize.f2};
    line-height: 125%;
    text-align: center;
    letter-spacing: 0.02em;
    color: ${(props) => props.theme.colors.blue};
    text-align: center;
  }
`;

export const GarageSliderItem = styled.div`
  padding: 0 6px;
  cursor: pointer;
  & > div {
    height: 130px;
  }
`;
